(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv2-header"]) return;
  try {
    
  (function () {
    /* Perkamiausių produktų pavadinimų sąrašas, nuo perkamiausio iki mažiausiai perkamo
       (pagal užsakymų skaičių per pastaruosius 365 dienas). Statinis, rankomis atnaujinamas
       momentinis vaizdas — ne realaus laiko duomenys. Naudojamas TIK paieškos pasiūlymų
       (predictive search) rikiavimui, nieko daugiau nekeičia. */
    var BEST_SELLING_TITLES = [
      "Flower™ | Lego Gėlių Advento Kalendorius",
      "Vandens pagrindo metalo rūdžių dažai + teptukas dovanų!",
      "Fisherman™ | Žvejybinis Advento Kalendorius",
      "Moteriški kvėpuojantys ortopediniai bateliai",
      "Fashion™ | Odiniai ortopediniai laisvalaikio sandalai",
      "Moteriškas maudymosi kostiumėlis su šortukais",
      "LunchBox - Termosinės dėžutės maistui (Rinkinys)",
      "Batų apkaustai nuo slydimo su dėklu (Pora)",
      "Madingi Ortopediniai bateliai",
      "BestClassic™ | Šiltos Elastingos paaukštinto liemens kelnės",
      "Šiltas kvėpuojantis dviejų dalių kostiumėlis",
      "CozyLights™ | LED Kalėdinės girliandos",
      "Brunex™ | Vyriški odiniai batai",
      "FrostMelt™ | Automobilio elektromagnetinis sniego atitirpinimo įrenginys",
      "ComfortStep™ | Patogūs ortopediniai bateliai kasdienai",
      "Moteriški madingi ortopediniai sandalai",
      "Labubu Advento Kalendorius",
      "Norway™ | Vyriškos žieminės kelnės",
      "Laisvo stiliaus moteriškas džinsinis bliuzonas",
      "Moteriškas megztinis su sagomis",
      "Moteriškas vienspalvis megztinis ilgomis rankovėmis",
      "Kalėdinis \"Stičų\" Advento kalendorius - apyrankių rinkinys 24vnt",
      "Moteriškas 3 dalių komplektas su ilgu kardiganu, topu ir kelnėmis",
      "Lusso™ | Moteriška striukė megztomis rankovėmis",
      "Šunyčių patrulių 24 dienų Advento Kalendorius",
      "Dviejų dalių maudymosi kostiumėlis su išskirtiniu dizainu",
      "Pasaulio Futbolo Čempionato Advento Kalendorius",
      "Calia™ | Moteriškos Itališkos Odinės Basutės",
      "Vyriški patogūs odiniai sandalai",
      "Vintage™ | Moteriški odiniai bateliai",
      "Moteriškas oversize bliuzonas su gobtuvu  ir užtrauktuku",
      "MINECRAFT | Magnetinių blokų rinkinys + dovana",
      "Pirštų separatorius komfortui ir nykščio padėčiai",
      "V8 Variklio modelio rinkinys",
      "Moteriška permatoma paplūdimio skraistė",
      "VeloCity™ | Vyriški odiniai batai",
      "Patogūs ortopediniai sandalai",
      "Minimalistinio stiliaus suknelė kasdienai",
      "BuildPro™ | Universalus kniedžių ir vinių pistoleto rinkinys",
      "Lego™ | Vaikiškas Minecraft Advento Kalendorius",
      "Ultra SSD Atmintinė - Išsaugok viską",
      "24 dienų Lego™ Advento Kalendorius",
      "Silikoninė vandens sulaikymo juosta",
      "Švelnus Moteriškas kardiganas",
      "Rankų darbo kavos puodelis - Literatūros Vitražas",
      "Moteriška skraistė - pončas",
      "Vyriški odiniai sandalai",
      "Kontūro matuoklio profilio įrankis",
      "Moherio mezgimo siūlų rinkinys",
      "Kalėdinis Advento Kalendorius su Pliušiniais Žaisliukais",
      "Vienspalvės tiesaus kirpimo kelnės moterims",
      "Prabangus dviejų dalių maudymosi kostiumėlis su auksine detale",
      "Šiltas patogus kombinezonas su užtrauktuku šunims",
      "Keraminis puodelis mechanikui su įrankių dizainu",
      "Moteriška modernaus stiliaus dygsniuota striukė su gobtuvu",
      "Moteriškas blizgus dviejų dalių kostiumėlis",
      "Kalėdinė dekoracija - Elnių šeima (3vnt)",
      "Gėrimų dozatorius su LED ekranu",
      "Dviejų dalių moteriškas komplektas su raštuotu ilgu sijonu",
      "Alpakos vilnos mezgimo siūlų rinkinys",
      "Patogūs vyriški džinsai su kišenėmis",
      "Juvelyrinių dirbinių valymo rinkinys",
      "Gėlėmis puošti ortopediniai bateliai",
      "Šiltas vilnonis moteriškas megztukas",
      "Šilta antivėjinė veido kaukė žiemai",
      "Belaidis turbo oro pūstuvas (Komplektas)",
      "Moherio Mezgimo Siūlai",
      "FunRace™ | Vaikiškas vairavimo žaislas",
      "Kalėdinis advento kalendorius - apyrankių rinkinys",
      "Itin lengvi ir patogūs darbo batai",
      "Madingi Moteriški Ortopediniai Bateliai",
      "Medinė sieninė dekoracija – kryžius su širdimi",
      "Dažomasis šampūnas žiliems plaukams",
      "Comfy™ | Šilti kūdikių batukai",
      "Šiltas pliušinis megztinis su laukinio katino motyvu",
      "Vyriški lininiai laisvalaikio marškiniai",
      "Vaikiškas mikrofonas su stovu ir šviesomis",
      "Moteriška nesiraukšlėjanti maxi suknelė",
      "Moteriškos medvilninės kelnės su elastingu juosmeniu",
      "Kalėdinė Jėzaus gimimo dekoracija su šviesomis",
      "Šiltas patogus kombinezonas šunims",
      "SmartKids™ | Vaikiškas įrankių rinkinys",
      "Nerūdijančio plieno matavimo ruletė PrecisionSteel™",
      "AllComfort™ | šiltas megztinis platesnėmis rankovėmis",
      "24 dienų Sonic Advento Kalendorius",
      "Šventinis moteriškas megztukas kasdieniam nešiojimui",
      "Sportiniai vasariniai sandalai su raišteliais „Active Glow“",
      "Warmy™ | Šilta žieminė neperšlampama striukė šunims",
      "Vyriški rudeniniai batai",
      "Stilingi Lengvi Moteriški Bateliai",
      "Sparks™ | Suknelė su iškirpimais",
      "Magnetinis Advento Kalendorius",
      "Kalėdinis reakcijos lavinimo žaidimas",
      "Raxon™ | Vyriški odiniai laisvalaikio batai",
      "Bellaria™ | Moteriška modernaus stiliaus striukė su gobtuvu",
      "ArcticGuard™ vilnonė striukė",
      "Statybos ir darbo mašinų Advento Kalendorius",
      "Patogūs odiniai moteriški sandalai",
      "Moteriškos patogios odinės basutės",
      "LunaFit™ | Elastingi paaukštinto liemens džinsai",
      "FrostMelt™ | Automobilio elektromagnetinis aromatizatorius",
      "Aliuminio sutvirtinimo strypai - 6vnt.",
      "\"Saulės Angelas\" - Šviečianti statula su saulės baterija",
      "\"Freedom Fit\" tamprūs paaukštinto liemens džinsai",
      "Šiltos įsispiriamos šlepetės su 3D kate",
      "Šifono suknelė \"Gėlelė\"",
      "Vyriški lininiai marškiniai",
      "Ortopediniai sportiniai kvėpuojantys bateliai",
      "Moteriški odiniai sandalai",
      "Michigan™ | Moteriškas laisvas dviejų dalių kostiumėlis",
      "Kalėdinė staltiesė",
      "Veltron™ | Vyriški laisvalaikio batai",
      "Premium Viskio Advento Kalendorius 2025",
      "Minkštas, šiltas megztinis moterims",
      "FlappyBird™ | Interaktyvus kačių žaislas",
      "Balta gėlėta suknelė",
      "Vyriški odiniai rudeniniai batai",
      "Smaragdinė laisva suknelė su dirželiu",
      "Naktinio vairavimo akiniai",
      "Magiškos valymo šluostės - daugkartinio naudojimo",
      "Gradientiniai Moherio Mezgimo Siūlai - Rinkinys",
      "Neperšlampama striukė šunims",
      "Moteriški odiniai bateliai su patogiu kulniuku",
      "Korėjietiška stangrinamoji kaukė | COLLAGMASK (20vnt rinkinys)",
      "Keraminis ir Hidrofobinis automobilio apsauginis purškalas",
      "Dolcena™ | Prabangūs Moteriški Bateliai",
      "3D Kariniai geležiniai puodeliai",
      "24 dienų \"Stich\" Advento Kalendorius",
      "Šiltas ir lengvas pledas vaikams su dinozaurais",
      "Neperšlampami batai su kailiuku",
      "Moteriška spalvotų juostų palaidinė su džinsinėmis detalėmis",
      "Karven™ | Vyriški odiniai laisvalaikio batai",
      "FEETFLEX™ – VYRIŠKI BATAI",
      "Vero™ | Moteriška pūkinė striukė su gobtuvu",
      "Stilingas Moteriškas Laisvalaikio Švarkas",
      "Rosse™ | Moteriška dvipusė striukė su kailiuku",
      "Profesionalus peilių galąstuvas",
      "Moteriški odiniai aulinukai su storu kulnu",
      "Moteriškas leopardinis kailinis paltas",
      "LUCAS - Vyriškas prabangus drabužių komplektas!",
      "BounceWave™ | Plaukų šepetys garbanų formavimui",
      "Besiūlė Formuojanti Moteriška Liemenėlė",
      "3D geležinis puodelis - bokso pirštinė",
      "\"TV Evolution\" - Kanalų ir Transliacijų perdavimo įrenginys",
      "Įkraunamas aukšto slėgio plovimo įrenginys (komplektas)",
      "Vintage stiliaus Moteriškos šlepetės su kailiuku",
      "U formos elektrinis dantų šepetėlis vaikams",
      "Tropinis figūrą formuojantis tankini kostiumėlis",
      "Stella™ | Lengva lininė suknutė su kišenėmis",
      "Japoniškas rankų darbo peilis",
      "Ilgalaikis antakių pieštukas natūraliam efektui (1+1)",
      "Elegantiška moteriška suknelė su tinklelio detalėmis",
      "ComfyStep™ | Moteriški patogūs batai su kailiuku",
      "Augalų augimą skatinantis papildas (1+1)",
      "Akumuliatorinis dažų purkštuvas (Komplektas)",
      "Švelnus ir minkstas medvilninis švarkelis",
      "Švelnus Moteriškas gėlių puoštas kardiganas",
      "Vandeniui atsparus blizgus tušas blakstienoms",
      "Vakariniai odiniai aukštakulniai „Orchidėja“",
      "Puošni suknelė (S-5XL)",
      "Patogūs Moteriški Bateliai",
      "Motociklo formos žadintuvas – laikrodis",
      "Moteriški elegantiški batai su storu kulnu",
      "Megztinis su apvalia apykakle ir kaspinu",
      "Madinga suknelė su V formos iškirpte (S-5XL)",
      "Kvėpuojantys ortopediniai bateliai",
      "Kalėdinis Alaus Advento Kalendorius",
      "CosyWave™ | šiltas megztinis nėriniuotomis rankovėmis",
      "Švelnus Moteriškas kardiganas su gobtuvu",
      "Vyriški neslystantys odiniai sandalai",
      "Termo vyriškas megztinis",
      "Roseo™ | Prabangus Moteriškas Megztukas",
      "Premium Jack Daniels 24 Dienų Advento Kalendorius",
      "Outdoor™ | Vyriški žygio batai",
      "Ocean™ | Maudymosi kostiumėlis paaukštintu liemeniu 3 dalių",
      "Moteriškos odinės ortopedinės basutės",
      "Moteriški, šilti įsispiriami mokasinai su polarine vilna",
      "Moteriškas patogus dviejų dalių kostiumėlis",
      "Moteriška palaidinė su leopardo rašto detalėmis",
      "Magiškas 5 dalių pižamų rinkinys",
      "Kašmyro ir Merino vilnos mezgimo siūlai",
      "Išskirtinio grožio suknelė (L-5XL)",
      "Išskirtinio dizaino kavos puodelis su V6 / V8 variklio motyvu",
      "Interaktyvus žaidimas dviems - \"Fast Sling Puck\"",
      "Grazia™ | Moteriški odiniai bateliai",
      "FrostShield™ striukė su vilnos pamušalu",
      "Flower™ | Šifono suknelė",
      "Elegantiški ortopediniai bateliai",
      "Brillanza™ | Prabangūs Moteriški proginiai bateliai",
      "Švarkelis išskirtine apykakle",
      "Vintage™ | Moteriški lengvi odiniai bateliai",
      "Stilingi Moteriški odiniai sandalai",
      "Prabangūs Odiniai Moteriški Bateliai",
      "Patogi moteriška suknelė su džinso detalėmis",
      "Neperšlampami žieminiai batai šunims (4 vnt.)",
      "Moteriški pliušiniai batai",
      "Moteriški odiniai batai su raišteliais",
      "Magiškas vamzdžių valiklis",
      "Lininės moteriškos laisvos kelnės",
      "Laisva suknelė",
      "Klasikinė juoda suknelė moterims",
      "Harry Potter 24 dienų Advento Kalendorius",
      "Šilta Moteriška striukė - Komfort",
      "ZipFix™ nuimamų užtrauktukų rinkinys (15 vnt.)",
      "WORKBOSS™ - Vyriškos kelnės",
      "Vyriški sportiniai laisvalaikio batai",
      "Vyriški kvėpuojantys odiniai batai",
      "Vasariška šifono suknelė „Gėlių šokis“",
      "Vasarinis paplūdimio kostiumėlis",
      "Vandeniui atsparių sandarinimo klijų rinkinys",
      "Stilingi moteriški sandalai",
      "Stilingi Moteriški Ortopediniai Bateliai",
      "Rozmarinų aliejus plaukų augimui",
      "Raštuota vasarinė suknelė",
      "Pokemon™ | Vaikiškas Advento Kalendorius",
      "Patogūs odiniai sandalai su užtrauktuku",
      "Paplūdimio kostiumėlis",
      "Moteriška pūkinė striukė su kailiuku",
      "Magnetinis kelio įtvaras",
      "Madingi Moteriški Ortopediniai Sandalai",
      "MINECRAFT | Magnetinių blokų rinkinys",
      "Luminosa™ | Išskirtinio grožio palaidinė su sagomis",
      "Laisvo kirpimo moteriškos lininės kelnės",
      "Klasikiniai moteriški odiniai aulinukai",
      "Ilga medvilninė suknelė",
      "Elegancéa™ | Moteriškas vientisas dviejų dalių kostiumėlis",
      "Daugiafunkcinė Magiška plovimo šluota",
      "Cavalier™ | Vyriški odiniai batai",
      "Belliora™ | Moteriški lengvi odiniai sandalai",
      "3 dalių kostiumėlis paaukštintu liemeniu",
      "12 dienų Lego Advento Kalendorius",
      "Įvairių batų platintojas",
      "Vyriški tvirti odiniai batai",
      "Vyriški odiniai sandalai \"Mustang\"",
      "Vyriški odiniai batai",
      "Vyriški laisvalaikio odiniai sandalai",
      "Vintage - Prabangi gėlių puošta odinė rankinė",
      "Unikali dekoracija - Lietaus būgnas",
      "SantaDecor™ | Kalėdiniai dovanų maišeliai",
      "Prakartėlė - rankų darbo dekoracija",
      "PopWars™ | Medinių lėlių žaidimas - susprogdink ir Laimėk!",
      "Outdoor™ Neperšlampama unisex sportinė striukė",
      "Ortopediniai madingi žiemos bateliai",
      "Moteriškos lininės kelnės",
      "Moteriški žieminiai ilgaauliai batai su pašiltinimu",
      "Medvilninė elegantiška suknelė",
      "Leya™ | Moteriški odiniai vilnoniai bateliai",
      "Lengvi moteriški odiniai sandalai",
      "Laisvi lininiai moteriški marškiniai",
      "Kalėdinis projektorius",
      "Gosep™ | Stilingas Moteriškas paltas su dirželiu",
      "Elektrošoko savigynos žiedas",
      "Daugiafunkcinis automobilio šildytuvas",
      "2024 NAUJIENA⭐️ Elegantiška suknelė (XXS-5XL)",
      "\"Simfonija\" - Laisva suknelė su dirželiu",
      "\"Autumn Style\"- Stilingi bateliai su kailiuku",
      "Šilta Moteriška striukė su gobtuvu",
      "Vyriškos odinės šlepetės",
      "Vyriški žieminiai batai su kailiuku",
      "Vielinis šepetys trimeriui",
      "Vaikiški rudeniniai odiniai batai",
      "Unisex namų šlepetės",
      "Stilingi moteriški ortopediniai sandalai",
      "Stilingas dviejų dalių kostiumėlis",
      "Stilinga elegantiška suknelė (S-5XL)",
      "RainbowBall™ | Spalvotų rutuliukų stalo žaidimas",
      "Prabangi Elegantiška suknelė (S-5XL)",
      "Moteriškos stilingos odinės basutės",
      "Moteriški patogūs ortopediniai sandalai",
      "Moteriški ortopediniai batai su kailiuku",
      "Moteriška skrybėlė nuo saulės",
      "Moteriška prailginta striukė su šiltu kailiuku viduje",
      "Modiva™ | Moteriški odiniai sandalai",
      "Minkštas sofos ir pagalvių užvalkalas",
      "Gėlių puošta moteriška palaidinė",
      "Elegantiška taškuota midi suknelė",
      "EIGONA™ Išskirtinė medvilninė suknelė",
      "Dekoratyvinis vonios kilimėlis su 3D iliuzija",
      "Dekoracija su Jėzaus atvaizdu",
      "Automobilio porankio organizatorius iš PU odos",
      "Ančiukų Advento Kalendorius",
      "Šifono suknelė",
      "Vyriška šilta flisinė striukė su etniniais raštais",
      "Universalūs kėdžių užvalkalai",
      "Stilingi odiniai aulinukai su kailiuku",
      "Solevida™ | Moteriški odiniai ortopediniai bateliai",
      "Skaitmeninis kampų ir nuolydžio matuoklis",
      "Rosabella™ | Gėlių puošti žieminiai bateliai",
      "PetSanta ™ | Gyvūnų Advento Kalendorius",
      "Patogus dviejų dalių kostiumėlis",
      "Nanccy™ | Prisitaikantys, ortopediniai, diabetiniai batai",
      "Moteriškos basutės su dirželiu ir žėrinčiomis detalėmis",
      "ModernHouse™ | Išskirtinio dizaino 3D savilipiai tapetai (10vienetų rinkinys)",
      "Ilga V formos medvilninė suknelė",
      "Elegantiška suknelė",
      "Elegantiška moteriška satininė palaidinė su perlais prie kaklo",
      "Dygsniuotas pledas „Miegantys katinai“",
      "\"SculptFlex\" tamprios paaukštinto liemens kelnės",
      "Magiškas batų balinimo valiklis (1+1)"
    ];

    var bestSellingRank = {};
    for (var bi = 0; bi < BEST_SELLING_TITLES.length; bi++) {
      bestSellingRank[BEST_SELLING_TITLES[bi]] = bi;
    }

    function sortByBestSelling(products) {
      var withIndex = products.map(function (p, i) { return { p: p, i: i }; });
      withIndex.sort(function (a, b) {
        var ra = bestSellingRank.hasOwnProperty(a.p.title) ? bestSellingRank[a.p.title] : Infinity;
        var rb = bestSellingRank.hasOwnProperty(b.p.title) ? bestSellingRank[b.p.title] : Infinity;
        if (ra !== rb) return ra - rb;
        return a.i - b.i;
      });
      return withIndex.map(function (x) { return x.p; });
    }

    function debounce(fn, wait) {
      var t;
      return function () {
        var args = arguments, ctx = this;
        clearTimeout(t);
        t = setTimeout(function () { fn.apply(ctx, args); }, wait);
      };
    }

    function escapeHtml(s) {
      return (s || '').replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function renderResults(container, input, products) {
      if (!products || !products.length) {
        container.innerHTML = input.value.trim().length >= 2
          ? '<div class="nv2-predictive-empty">Rezultatų nerasta</div>'
          : '';
        container.hidden = container.innerHTML === '';
        input.setAttribute('aria-expanded', container.hidden ? 'false' : 'true');
        return;
      }

      var html = '<ul class="nv2-predictive-list" role="listbox">' + products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
        return '<li class="nv2-predictive-item" role="option">' +
          '<a href="' + p.url + '" class="nv2-predictive-link">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="44" height="44">' : '') +
          '<span class="nv2-predictive-info">' +
          '<span class="nv2-predictive-title">' + escapeHtml(p.title) + '</span>' +
          (p.price ? '<span class="nv2-predictive-price">' + p.price + '</span>' : '') +
          '</span></a></li>';
      }).join('') + '</ul>';

      container.innerHTML = html;
      container.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function wireForm(wrap) {
      var input = wrap.querySelector('input[type="search"]');
      var container = wrap.querySelector('[data-nv2-predictive-results]');
      if (!input || !container) return;

      var currentQuery = null;

      var runSearch = debounce(function () {
        var q = input.value.trim();
        currentQuery = q;

        if (q.length < 2) {
          renderResults(container, input, null);
          return;
        }

        var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
        var url = base + '?q=' + encodeURIComponent(q) +
          '&resources[type]=product' +
          '&resources[limit]=10' +
          '&resources[options][unavailable_products]=last';

        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (q !== currentQuery || !data) return;
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(container, input, sortByBestSelling(products).slice(0, 6));
          })
          .catch(function () { renderResults(container, input, null); });
      }, 250);

      input.addEventListener('input', runSearch);

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && container.innerHTML) {
          container.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          container.hidden = true;
          input.setAttribute('aria-expanded', 'false');
        }
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          container.hidden = true;
          input.setAttribute('aria-expanded', 'false');
        }
      });
    }

    function init() {
      document.querySelectorAll('.nv2-header__search-wrap, .nv2-header__search-m').forEach(wireForm);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
